"use strict";

exports.__esModule = true;
exports.CommentTableFields = void 0;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _Fields = require("../AdvancedDataTable/Fields");
var _comments = require("../DataTable/DataSources/comments");
var _DataTable = require("../DataTable");
var _DataTableColumn = require("../DataTableColumn");
var _Fields2 = require("../DataTable/Fields");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields for DataTableElement.
 */
var CommentTableFields = exports.CommentTableFields = function CommentTableFields(props) {
  var translator = _react["default"].useContext(_Core.TranslatorContext);
  var translate = translator.translate;
  var path = props.path,
    elementEditor = props.elementEditor,
    element = props.element;
  var definition = (0, _comments.commentsDefinition)(translate);
  var configuration = element.props.configuration;
  if (!configuration) {
    configuration = (0, _DataTable.boostrapDefaultColumns)(configuration, elementEditor, definition, path);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Fields2.AddColumnField, {
    dataSourceDefinition: definition,
    onAddColumn: function onAddColumn(column) {
      elementEditor.appendElementAt(path, _DataTableColumn.DataTableColumnWidget.createElement(Object.assign({}, column)));
    }
  }), /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedDataRangeSelector, {
    setProp: function setProp(value) {
      elementEditor.setProp(path, "dataRange", value);
    },
    value: element.props.dataRange || "",
    fetchDataOnlyOnSelection: element.props.fetchDataOnlyOnSelection,
    setFetchOnlyOnSelection: function setFetchOnlyOnSelection(value) {
      elementEditor.setProp(path, "fetchDataOnlyOnSelection", value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Fields2.PaginationField, {
    defaultPageSize: configuration.defaultPageSize,
    setDefaultPageSize: function setDefaultPageSize(val) {
      return elementEditor.setProp(path, "configuration", Object.assign({}, element.props.configuration, {
        defaultPageSize: val
      }));
    }
  }));
};